import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { media } from "@/lib/api";
import { Badges } from "./Bits";
import { Tilt } from "./Motion";

export const ArtistCard = ({ a, i = 0 }) => (
  <Tilt><Link to={`/a/${a.slug}`} data-testid={`artist-card-${a.slug}`}
    className="group fade-up relative block overflow-hidden rounded-2xl border border-white/8 bg-[#0F1420] transition-[transform,border-color] duration-300 hover:-translate-y-1 hover:border-[#FF2E63]/50"
    style={{ animationDelay: `${i * 0.05}s` }}>
    <div className="relative aspect-[4/5] overflow-hidden">
      {a.photo ? <img src={media(a.photo)} alt={a.stage_name} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" /> : <div className="vinyl h-full w-full" />}
      <div className="absolute inset-0 bg-gradient-to-t from-[#07090E] via-[#07090E]/10 to-transparent" />
      <span className="absolute left-3 top-3 rounded-full bg-[#07090E]/70 px-2.5 py-1 font-mono text-[10px] uppercase tracking-widest text-[#00F5D4] backdrop-blur">{a.role_type} · {a.genre}</span>
      <div className="absolute inset-x-0 bottom-0 p-4">
        <h3 className="font-display text-2xl font-extrabold uppercase leading-none">{a.stage_name}</h3>
        {a.city && <div className="mt-1 flex items-center gap-1 text-xs text-slate-400"><MapPin className="h-3 w-3" />{a.city}</div>}
        <Badges badges={a.badges} plan={a.plan} className="mt-3" />
      </div>
    </div>
  </Link></Tilt>
);
